/* ------------
Cookie Helpers
------------ */
function setCookie( name, val, expiration ){
    document.cookie = name+"="+val+"; expires="+expiration;
}

function deleteCookie(name){
    document.cookie = name+"=null; expires=Thu, 01 Jan 1970 00:00:01 GMT";
}

function getCookie( name ){
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

 function getExpirationDate(time) {
    return new Date(time).toUTCString();
 };

 export { setCookie, deleteCookie, getCookie, getExpirationDate };